export enum MapMarkerType {
    home = 'home',
    company = 'company',
    carerMale = 'carer_male',
    carerFemale = 'carer_female',
    clientMale = 'client_male',
    clientFemale = 'client_female',
    checkIn = 'check_in',
    checkOutUnconfirmed = 'check_out_unconfirmed',
    checkOutConfirmed = 'check_out_confirmed'
}
